/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:54:42 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormControl, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { Checkbox, CheckboxProps } from "@mui/material";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

type CheckBoxFormInputProps<T> = Omit<OSFormInputProps<T>, "control"> &
  CheckboxProps &
  Omit<FormControlLabelProps, "control">;

export const CheckBoxFormInput = <T,>(props: CheckBoxFormInputProps<T>) => {
  const {
    controlledProps,
    field: { onChange, value },
  } = useControlledInput<T>(props);

  const checkBoxInput = <Checkbox {...controlledProps} onChange={onChange} checked={value as boolean} {...props} />;

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          {props.label ? (
            <FormControl>
              <FormControlLabel control={checkBoxInput} {...props} />
            </FormControl>
          ) : (
            checkBoxInput
          )}
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
